// 普段のパリィの見た目「手本」(2026-10-15 ユーザー「だいぶ求めてる形になった」「いまのをデフォルトとしてブラッシュアップ」= 配布版の既定)。
//   前の既定 (毛先の紫・src/parry_kesaki_fx.ts) との見比べは DEV ?parryLook=kesaki-default (?parryLook=kesaki も同じ)。 旧の金の雲 = ?parryLook=old。
//   元 = ユーザー 10-15「レイピアで弾いて火花が散るような感じ」「(前の版の) 明るさ・派手さ／光がふわっと広がる所／火の粉は残す」
//        「(前は) 弾いたエフェクトと言うよりは特殊なことがあって一瞬時が止まった演出になってる」。
//   手本 = ゼンゼロ (本人の録画) と Lies of P のパリィをコマで読んだ物 (docs/research/2026-10-15-parry-model-zzz-liesofp.md)。 共通5点を作る：
//     ① 弾いて 0.03〜0.1 秒に画面全体が明るくなり 0.2 秒以内に戻る (drawTehonScreenFlash)
//     ② 接点から細く長い火花のすじが数十本、放射状に飛ぶ (drawTehonStreaks・飛んで消える火花。 線の図形ではない。
//        10-22 から頭の白→黄→金→橙→燠へ色が移り、飛ぶほど冷める = SPARK_RAMP・前の版 ?sparkGrad=off)
//     ③ 接点の光は輪郭のぼやけた大きな塊がふわっと広がって消える (drawTehonBloom)
//     ④ 画面幅いっぱいの横一直線の光が 0.1〜0.3 秒 (drawTehonFlare・10-15 ユーザー「入れていい・棒の図形にしない」=
//        中心ほど明るく太く、端へ細く薄く。 長さの違う横長のにじみを重ねて濃淡を出し、消える時は細りながら薄れる)
//        → 10-21 から出さない (「横に一瞬映る金色の線」で目が疲れる・前の版 = DEV ?parryFlare=on)
//     ⑤ 光が引いた後に火の粉が 0.2〜0.4 秒漂い落ちる (drawTehonEmbers)
//   色 = 白と金が主、主人公の髪の紫を少し (ゼンゼロの配色に近い)。 赤は使わない。
//   白黒は出さない。 光は止めの間も進む (弾いてからの秒で動く)。 止め (ヒットストップ) は 10-16 から前の長さ (TEHON.stopMs = 上限なし)。
//   致命の弾き (exec) は受け持たない (今のまま = 毛先の紫＋白黒＋スロー)。
//
//   既定にしてからの直し (10-15 夜):
//     ・弾いて 1〜2 コマ (30fps) で接点に近い主人公の上半身が光に埋もれていた → やわらかい光 (塊・横・斜め) を描いた後に主人公の体を
//       半分ほどの濃さで描き直し、金の縁を足し直す (tehonVeilAlpha)。 火花のすじと火の粉はその上 = 体の前を飛ぶ。
//     ・3 コマ目で遅く生まれたすじが接点のそばに固まって「ウニ」に見えた → すじは生まれる前から飛んでいた位置に出す (streak.pre)、
//       生まれる時刻を早い方へ寄せ、火の粉の生まれる場所を広く散らす。
//   10-16 パック tehon-brush の答え (ユーザー「Lies of P 寄り」「既定の短い止め」「斜めの紫の光は 無くていい」)
//     → 既定を Lies of P 寄りの値にした (金・橙の火花が主役・光は短く鋭く・火の粉の余韻を長く・斜めの光なし・止めは 50ms のまま)。
//   10-16 ユーザー「連撃のテンポが少し変わってる気がする」「ヒットストップの長さは前の長さにしてほしい」
//     → 50ms の頭打ちで弾くたびに 0.1〜0.24 秒止めが短くなり、ボスの次の一撃が早く来ていた。 既定の止めを前の長さへ戻した
//        (150ms × 強さ × 連続の倍率・1回 約 0.16〜0.2 秒・続けて弾くと最大 約 0.3 秒)。 見た目はそのまま。
//   見比べの案 (DEV だけ・?parryLook=<値>・どれも致命の弾きは今のまま)：
//     tehon-v1     = 1つ目の既定 (10-15 夜〜10-16)。 白・金にすみれの斜めの光 2 本。 止め 50ms。
//     tehon-zzz    = ゼンゼロ寄り (1つ目の既定から)。 斜めの桃紫の光の帯を太く長く (画面の端から端へ・棒でなくにじみ)、全体に紫を多め。
//     tehon-lop    = 今の既定と同じ (案だった時の名前)。
//     tehon-nostop = 止め (ヒットストップ) なし。 見た目は今の既定と同じ。
//     tehon-yori   = 止めの代わりに寄る。 止めなし＋接点へ 6% ほど寄ってすぐ戻る (時を止めずに「当たった」重さを出す試し)。
//
// 時間の数え方 = src/parry_kesaki_fx.ts の kesakiClock の since (弾いた瞬間からの秒・止めの間も進む)。
import type { FxEvent } from './types'

type Spark = Extract<FxEvent, { kind: 'parry_spark' }>
type RGB = readonly [number, number, number]

// ---- スイッチ -------------------------------------------------------------------------------------
export type TehonVariant = 'base' | 'v1' | 'zzz' | 'lop' | 'nostop' | 'yori'
/** off = 手本を使わない (毛先の紫・旧の金の雲で見比べる時)。 */
export type TehonLook = TehonVariant | 'off'
export const TEHON_VARIANTS: readonly TehonVariant[] = ['base', 'v1', 'zzz', 'lop', 'nostop', 'yori']
/** ?parryLook の値 → 手本の案。 毛先の紫・旧の値は off。 知らない値・指定なしは null (= 既定の手本)。 */
export function parseTehonLook(v: unknown): TehonLook | null {
  const k = typeof v === 'string' ? v.toLowerCase() : ''
  if (k === 'tehon') return 'base'
  if (k.startsWith('tehon-')) {
    const sub = k.slice(6)
    return sub !== 'base' && (TEHON_VARIANTS as readonly string[]).includes(sub) ? sub as TehonVariant : null
  }
  if (k === 'old' || k === 'now' || k === 'kesaki' || k === 'kesaki-default' || k === 'kesaki-shadow') return 'off'
  return null
}
let look: TehonLook = 'base'   // 既定 = 手本 (配布版は常にこれ)
if (import.meta.env.DEV && typeof window !== 'undefined') {
  look = parseTehonLook(new URLSearchParams(window.location.search).get('parryLook')) ?? 'base'
  // 撮影用: true/false で入切、案の名前 (base・v1・zzz・lop・nostop・yori・off か ?parryLook の値) で切り替え。 引数なしで今の値を返す。
  ;(window as any).__setParryTehon = (next?: unknown): TehonLook => {
    if (typeof next === 'boolean') look = next ? 'base' : 'off'
    else if (typeof next === 'string') {
      const k = next.toLowerCase()
      look = k === 'off' ? 'off' : (TEHON_VARIANTS as readonly string[]).includes(k) ? k as TehonVariant : parseTehonLook(k) ?? look
    }
    return look
  }
}
export function parryTehonOn(): boolean { return look !== 'off' }
export function tehonLook(): TehonLook { return look }
/** テスト用。 true = 既定の手本・false = 使わない。 */
export function setParryTehonForTest(next: boolean | TehonLook): void { look = typeof next === 'boolean' ? (next ? 'base' : 'off') : next }
/** この弾きを「手本」が受け持つか (普段のパリィだけ。 致命の弾きは受け持たない)。 */
export function tehonOwns(f: FxEvent, active: boolean = look !== 'off'): f is Spark {
  return active && f.kind === 'parry_spark' && !f.exec
}
/** tehonOwns の真偽だけ版 (型を絞らない = 呼ぶ側の else で他の描き方が型から消えない)。 */
export function tehonTakes(f: FxEvent, active: boolean = look !== 'off'): boolean { return tehonOwns(f, active) }

// 火花の形 (10-23 ユーザー「形を変えるなら、どれが良いですか：Bを見たい。変だったら今の形でいい」)。
//   b = 形B「溶けた鉄の滴」(見本の絵 そざい/concept/parry-spark-1022/b_molten.png・Git 管理外) = DEV ?sparkShape=b。 描くのは src/parry_spark_molten.ts。
//   すじ・火の粉の代わりに、接点の星形の光・細かい飛沫・重い滴 (床で跳ねて、床に残って冷める) を描く。 色は ?sparkMix と組み合わせられる。
//   b2 = 形B の強め (10-23・滴を大きく多く・星を長く・飛沫を倍) = DEV ?sparkShape=b2。 値は src/parry_spark_molten.ts の MOLTEN_STRONG。
export type SparkShape = 'now' | 'b' | 'b2'
let sparkShape: SparkShape = (() => {
  if (!import.meta.env.DEV || typeof window === 'undefined') return 'now'
  const v = new URLSearchParams(window.location.search).get('sparkShape')
  return v === 'b' || v === 'b2' ? v : 'now'
})()
export function tehonSparkShape(): SparkShape { return sparkShape }
export function setTehonSparkShapeForTest(s: SparkShape): void { sparkShape = s }
/** 形B の全部が消えるまでの秒 (床に残った滴が冷めきるまで)。 */
export const MOLTEN_END = 0.8

// ---- 色 -------------------------------------------------------------------------------------------
/** 色。 白・金が主、髪の紫を少し (すみれ寄りの淡い紫・溜めの濃い紫にはしない)。 赤なし。 */
export const TEHON_COLOR = {
  white: [255, 252, 244] as RGB,
  warm: [255, 236, 196] as RGB,
  gold: [255, 196, 102] as RGB,
  amber: [255, 168, 72] as RGB,
  violet: [196, 150, 255] as RGB,
  violetPale: [236, 222, 255] as RGB,
  /** 主人公の髪の明るいすみれ #C9A0FF (KESAKI_HAIR_RAMP の中ほど)。 斜めの光の色。 */
  hair: [201, 160, 255] as RGB,
  /** ゼンゼロ寄り (tehon-zzz) の斜めの帯の桃紫と、その芯の淡い色。 赤には寄せない (r と g の差は 100 未満)。 */
  pink: [236, 150, 255] as RGB,
  pinkPale: [250, 226, 255] as RGB,
} as const

// ---- 値 -------------------------------------------------------------------------------------------
export type TehonParams = {
  /** 止めの上限 (ms)。 普段のパリィは 150ms × 強さ × 連続の倍率。 Infinity = 頭打ちなし (前の長さのまま・10-16 の既定)。 50 = 3 コマで頭打ち (tehon-v1)。 0 = 止めなし。 */
  stopMs: number
  /** 寄り。 null = 前からの小さな寄り (parry_bloom_fx.ts の bloomZoom)。 amp = 寄る割合・in 秒で寄り切り・out 秒で戻り切る。 */
  zoom: { amp: number; in: number; out: number } | null
  /** ① 画面の明るさ: 弾いて rise 秒で一番明るく、end 秒で戻り切る。 peak = 画面全体に足す色の濃さ・spot = 接点まわりに足す濃さ。 */
  flash: { rise: number; end: number; peak: number; spot: number; tint: RGB; spotTint: RGB }
  /** ③ 接点の光の塊: 半径 r0→r1 へ広がる (ease out・grow 秒)・rise 秒で満ち、hold 秒まで保って end 秒で消える。 violet・gold = 外・中のにじみの濃さの倍率。 */
  bloom: { r0: number; r1: number; grow: number; rise: number; hold: number; end: number; violet: number; gold: number }
  /** ④ 横の光: in 秒で満ち、hold 秒まで保ち、end 秒で細りながら消える。 gain = 濃さの倍率 (0 = 出さない)。 */
  flare: { in: number; hold: number; end: number; gain: number }
  /**
   * ④' 接点を通る斜めの光。 peak 秒で一番明るく、end 秒で消える。 gain = 濃さの倍率 (0 = 出さない)。
   *   wide = ゼンゼロ寄りの太く長い桃紫の帯 (3 本・画面の端から端へ) にする。 false = 既定の淡い紫 2 本。
   */
  slash: { peak: number; end: number; gain: number; wide: boolean }
  /** ② 火花のすじ。 速さ (px/秒)・空気の抵抗・重さ・寿命・尾の長さ (速さ × trail 秒・1本ずつ違う)・頭の太さ (px)。 */
  streak: {
    count: number; spawn: number; spawnPow: number; pre: number
    speed: readonly [number, number]; drag: number; gravity: number
    life: readonly [number, number]; trail: readonly [number, number]; lenMax: number; width: readonly [number, number]
    detach: number; scatter: number
    /** 色の割合 (累積): 金 < tones[0] ≦ 琥珀 < tones[1] ≦ 白熱 < tones[2] ≦ 紫。 */
    tones: readonly [number, number, number]
  }
  /** ⑤ 火の粉。 出る時刻 (秒)・速さ・寿命・半径・尾 (速さ × tail 秒)・紫の割合・生まれる場所 (接点から dist[0] + dist[1] px の中)。 */
  ember: {
    count: number; born: readonly [number, number]; speed: readonly [number, number]; drag: number; gravity: number
    life: readonly [number, number]; size: readonly [number, number]; tail: number; violet: number; dist: readonly [number, number]
    /** 消え方の曲がり (濃さ = (1 - 寿命の割合) ^ fade)。 小さいほど終わり近くまで明るく残る。 */
    fade: number
  }
  /** 主人公の体を光の上に描き直す濃さ (0〜1・光が一番強い所で)。 光に埋もれた上半身の輪郭を読ませる。 */
  veil: number
}

/** 1つ目の既定 (10-15 夜〜10-16)。 白・金・すみれの斜めの光 2 本。 見比べは ?parryLook=tehon-v1。 */
const V1: TehonParams = {
  stopMs: 50,
  zoom: null,
  //   2回目 (10-15): 接点まわりの白が二人の体を消していた → 一様分も接点まわりも下げ、接点まわりは白でなく金寄りにした。
  //   既定化 (10-15 夜): 接点まわりをもう一段下げる (主人公の上半身が埋もれる・0.24 → 0.2)。
  flash: { rise: 0.05, end: 0.2, peak: 0.08, spot: 0.2, tint: TEHON_COLOR.warm, spotTint: TEHON_COLOR.warm },
  //   2回目: 画面の引きが広いので大きく (r1 = 画面の高さ 540 の約 4 割)。 白い芯は小さく、外の金・紫のにじみを大きく。
  bloom: { r0: 50, r1: 230, grow: 0.2, rise: 0.03, hold: 0.08, end: 0.3, violet: 1, gold: 1 },
  flare: { in: 0.04, hold: 0.1, end: 0.3, gain: 1 },
  //   2回目: ゼンゼロの斜めの帯を淡い紫で。
  slash: { peak: 0.05, end: 0.12, gain: 1, wide: false },
  //   2回目: 短く白い線が接点に揃って「ウニ」に見えた → 色の主役を金・琥珀に、速く長生きにして画面の3分の1より遠くまで飛ばし、
  //   尾の長さ・生まれる時刻 (spawn 秒の幅)・生まれる位置 (接点から scatter px の中) を1本ずつばらつかせる。
  //   3周目: 遅いすじが接点のそばに溜まってまだ放射の図形に見えた → 一番遅い物も速くし (すぐ接点を離れる)、生まれる位置を広く散らす。
  //   既定化: 3 コマ目で遅く生まれたすじがまだ接点に固まった → 生まれる前の分も飛んだ位置に出す (pre)・生まれる時刻を早い方へ寄せる (spawnPow)。
  streak: { count: 72, spawn: 0.07, spawnPow: 1.8, pre: 0.9, speed: [1100, 3400], drag: 3.4, gravity: 620,
    life: [0.16, 0.36], trail: [0.02, 0.075], lenMax: 260, width: [1.1, 2.6],
    /** 尾は飛んだ距離のこの割合まで (接点から生えた線に見せない = 接点から離れて飛ぶ火花)。 */
    detach: 0.55, scatter: 40, tones: [0.45, 0.76, 0.88] },
  //   2回目: 玉ボケに見えた → 小さく芯のはっきりした点にし、動く向きの後ろへ短い尾を引かせる。
  //   既定化: 接点のそばで生まれた粒が 3 コマ目の固まりに混ざった → 生まれる場所を外へ広げる。
  ember: { count: 26, born: [0.07, 0.14], speed: [60, 240], drag: 2.6, gravity: 380,
    life: [0.22, 0.34], size: [0.8, 1.6], tail: 0.035, violet: 0.18, dist: [30, 120], fade: 1.3 },
  veil: 0.6,
}

/**
 * 既定 (10-16〜) = Lies of P 寄り。 パック tehon-brush の答え (ユーザー 10-16「Lies of P 寄り」「既定の短い止め」「斜めの紫の光は 無くていい」)。
 *   止めは 1 つ目と同じ 50ms。 斜めの光は出さない (slash.gain 0)。
 */
const BASE: TehonParams = {
  ...V1,
  // 止めは前の長さ (10-16 ユーザー「ヒットストップの長さは前の長さにしてほしい」= 連撃のテンポを前に戻す)。
  stopMs: Infinity,
  // 光は短く鋭く (0.03 秒で一番明るく 0.13 秒で戻る)。 接点まわりは琥珀。
  flash: { rise: 0.03, end: 0.13, peak: 0.11, spot: 0.28, tint: TEHON_COLOR.warm, spotTint: TEHON_COLOR.amber },
  bloom: { r0: 50, r1: 200, grow: 0.12, rise: 0.025, hold: 0.06, end: 0.17, violet: 0.12, gold: 1.15 },
  flare: { in: 0.03, hold: 0.07, end: 0.22, gain: 1 },
  slash: { ...V1.slash, gain: 0 },
  // 金・橙のすじを多く・早く出し切る (紫は 2%)。
  streak: { ...V1.streak, count: 84, spawn: 0.04, tones: [0.4, 0.9, 0.98] },
  // 火の粉を倍に、早く生まれて長く漂い、重く落ちる。
  //   撮影1回目 (案の時): 0.33 秒でほぼ見えなくなっていた → 粒を少し大きく・終わり近くまで明るく (fade 1.3 → 0.7)。
  ember: { count: 50, born: [0.04, 0.08], speed: [70, 280], drag: 2.4, gravity: 560,
    life: [0.3, 0.4], size: [1, 2.1], tail: 0.04, violet: 0.04, dist: [30, 150], fade: 0.7 },
  veil: 0.55,
}

/** 既定と見比べの案の値。 どれもゲームが parry_spark を消す 0.5 秒より前に全部消える (tehonEnd)。 */
export const TEHON_PARAMS: Readonly<Record<TehonVariant, TehonParams>> = {
  base: BASE,
  v1: V1,
  zzz: {
    ...V1,
    // 少し遅く満ちて長めに保つ明るさ (ゼンゼロは 0.1〜0.13 秒が一番明るい)。 画面に足す色も桃紫へ寄せる。
    flash: { rise: 0.07, end: 0.22, peak: 0.1, spot: 0.2, tint: TEHON_COLOR.pinkPale, spotTint: TEHON_COLOR.pink },
    bloom: { ...V1.bloom, violet: 1.7, gold: 0.7 },
    slash: { peak: 0.06, end: 0.2, gain: 1, wide: true },
    streak: { ...V1.streak, tones: [0.3, 0.45, 0.7] },
    ember: { ...V1.ember, violet: 0.45 },
  },
  // Lies of P 寄りは 10-16 に既定になった (base と同じ値・?parryLook=tehon-lop の URL を生かすために残す)。
  lop: BASE,
  nostop: { ...BASE, stopMs: 0 },
  yori: { ...BASE, stopMs: 0, zoom: { amp: 0.06, in: 0.035, out: 0.28 } },
}
/** 既定 (配布版) の値。 */
export const TEHON = TEHON_PARAMS.base
/** 今の案の値 (手本を使わない時も既定の値)。 */
export function tehonP(): TehonParams { return TEHON_PARAMS[look === 'off' ? 'base' : look] }
/** 全部が消えるまでの秒 (弾いてから)。 ゲームが parry_spark を消す 0.5 秒より前。 */
export function tehonEnd(P: TehonParams = tehonP()): number {
  return Math.max(
    P.flash.end, P.bloom.end, P.flare.end, P.slash.end,
    sparkShape !== 'now' ? MOLTEN_END : 0,
    P.streak.spawn + P.streak.life[1], P.ember.born[1] + P.ember.life[1])
}
/** ゲームが普段のパリィの parry_spark を消すまでの秒。 形B (DEV ?sparkShape=b・b2) は滴が床に残る間だけ長く残す。 それ以外は 0.5 秒のまま。 */
export function tehonSparkFxLifeSec(): number { return sparkShape !== 'now' ? Math.max(0.5, MOLTEN_END + 0.02) : 0.5 }
/** 既定の全部が消えるまでの秒。 */
export const TEHON_END = tehonEnd(TEHON)

const clamp01 = (t: number) => Math.max(0, Math.min(1, t))
const easeOut = (t: number) => 1 - Math.pow(1 - clamp01(t), 3)
const smooth = (t: number) => { const x = clamp01(t); return x * x * (3 - 2 * x) }
export const rgba = (c: RGB, a: number) => `rgba(${c[0]},${c[1]},${c[2]},${clamp01(a).toFixed(3)})`
/** 0〜1 の決まった乱数 (同じ弾きでは毎コマ同じ値)。 */
export function h01(n: number): number { const s = Math.sin(n * 12.9898 + 78.233) * 43758.5453; return s - Math.floor(s) }
/** 弾きごとの種 (続けて弾いても同じ散り方にならない)。 */
export function tehonSeed(f: Spark): number { return (Math.round(f.t * 1000) % 9973) * 0.137 + (f.x % 97) * 0.31 }

// ---- 包絡 (0〜1) ----------------------------------------------------------------------------------
/** ① 画面の明るさ。 */
export function tehonFlashEnv(since: number, P: TehonParams = tehonP()): number {
  const F = P.flash
  if (since < 0 || since >= F.end) return 0
  if (since < F.rise) return easeOut(since / F.rise)
  return Math.pow(1 - (since - F.rise) / (F.end - F.rise), 2)
}
/** ③ 接点の光の塊の濃さと半径。 */
export function tehonBloomAt(since: number, P: TehonParams = tehonP()): { alpha: number; radius: number } {
  const B = P.bloom
  if (since < 0 || since >= B.end) return { alpha: 0, radius: B.r0 }
  const a = since < B.rise ? easeOut(since / B.rise) : since < B.hold ? 1 : Math.pow(1 - (since - B.hold) / (B.end - B.hold), 1.5)
  return { alpha: a, radius: B.r0 + (B.r1 - B.r0) * easeOut(since / B.grow) }
}
/** ④ 横の光の濃さ・太さの倍率・長さの倍率。 */
export function tehonFlareAt(since: number, P: TehonParams = tehonP()): { alpha: number; thick: number; length: number; fade: number } {
  const L = P.flare
  if (since < 0 || since >= L.end || L.gain <= 0) return { alpha: 0, thick: 0, length: 0, fade: 1 }
  const grow = easeOut(since / L.in)
  const fade = since <= L.hold ? 0 : (since - L.hold) / (L.end - L.hold)
  return {
    alpha: grow * Math.pow(1 - fade, 1.4),
    thick: (0.55 + 0.45 * grow) * (1 - 0.75 * smooth(fade)),
    length: 0.55 + 0.45 * grow + 0.18 * fade,
    fade,
  }
}
/** ④' 斜めの光の濃さと長さの倍率。 */
export function tehonSlashAt(since: number, P: TehonParams = tehonP()): { alpha: number; length: number } {
  const L = P.slash
  if (since < 0 || since >= L.end || L.gain <= 0) return { alpha: 0, length: 0 }
  const a = since < L.peak ? easeOut(since / L.peak) : Math.pow(1 - (since - L.peak) / (L.end - L.peak), 1.5)
  return { alpha: a, length: 0.6 + 0.4 * easeOut(since / L.peak) + 0.15 * clamp01((since - L.peak) / (L.end - L.peak)) }
}
/** 寄りの倍率 (案に寄りが無ければ null = 呼ぶ側が前からの小さな寄りを使う)。 */
export function tehonZoom(since: number, P: TehonParams = tehonP()): number | null {
  const Z = P.zoom
  if (!Z) return null
  if (since < 0 || since >= Z.out) return 1
  const k = since < Z.in ? easeOut(since / Z.in) : Math.pow(1 - (since - Z.in) / (Z.out - Z.in), 2)
  return 1 + Z.amp * k
}

// ---- ② 火花のすじ ---------------------------------------------------------------------------------
export type StreakSpec = { ang: number; speed: number; life: number; width: number; delay: number; trail: number; ox: number; oy: number; tone: 0 | 1 | 2 | 3 }
/** i 本目のすじ。 前 (ボスの方) へ 6 割強・残りは全周。 少し上へ寄せる。 tone 0 = 金・1 = 琥珀・2 = 白熱 (少し)・3 = 紫 (少し)。 */
export function tehonStreakSpec(i: number, seed = 0, P: TehonParams = tehonP()): StreakSpec {
  const S = P.streak
  const r = (k: number) => h01(i * k + seed)
  const fwd = r(3.71) < 0.64
  const deg = fwd ? (r(5.13) - 0.5) * 170 - 10 : r(7.77) * 360
  const toneU = r(9.31)
  const oa = r(11.3) * Math.PI * 2, od = S.scatter * Math.sqrt(r(12.7))
  return {
    ang: deg * Math.PI / 180,
    speed: S.speed[0] + (S.speed[1] - S.speed[0]) * Math.pow(r(2.17), 0.75),
    life: S.life[0] + (S.life[1] - S.life[0]) * r(6.43),
    width: S.width[0] + (S.width[1] - S.width[0]) * r(4.29),
    delay: S.spawn * Math.pow(r(8.61), S.spawnPow),
    trail: S.trail[0] + (S.trail[1] - S.trail[0]) * r(13.9),
    ox: Math.cos(oa) * od * 1.3, oy: Math.sin(oa) * od,
    tone: toneU < S.tones[0] ? 0 : toneU < S.tones[1] ? 1 : toneU < S.tones[2] ? 2 : 3,
  }
}
/**
 * すじの頭の位置 (生まれた点から・前 = +x)・速度・濃さ。 出る前・消えた後は null。
 *   位置は「生まれる前の delay × pre 秒も飛んでいた」として出す = 遅く生まれたすじが接点のそばに固まらず、飛んでいる途中で灯る。
 *   濃さ・寿命は生まれてからの秒で数える。
 */
export function tehonStreakAt(s: StreakSpec, since: number, P: TehonParams = tehonP()): { x: number; y: number; vx: number; vy: number; alpha: number } | null {
  const S = P.streak
  const lt = since - s.delay
  if (lt < 0 || lt >= s.life) return null
  const ft = lt + s.delay * S.pre
  const e = Math.exp(-S.drag * ft)
  const ux = Math.cos(s.ang), uy = Math.sin(s.ang)
  const d = s.speed * (1 - e) / S.drag
  const p = lt / s.life
  return {
    x: ux * d, y: uy * d + 0.5 * S.gravity * ft * ft,
    vx: ux * s.speed * e, vy: uy * s.speed * e + S.gravity * ft,
    alpha: Math.min(1, lt / (1 / 60)) * Math.pow(1 - p, 1.15),
  }
}
/** 頭 (熱い所)・体 (尾へ抜ける色)。 主役は金・琥珀、白熱のすじは少数 (白は頭の芯だけ)。 */
const STREAK_TONES: readonly { head: RGB; body: RGB }[] = [
  { head: TEHON_COLOR.warm, body: TEHON_COLOR.gold },
  { head: TEHON_COLOR.gold, body: TEHON_COLOR.amber },
  { head: TEHON_COLOR.white, body: TEHON_COLOR.warm },
  { head: TEHON_COLOR.violetPale, body: TEHON_COLOR.violet },
]

// 火花の色の移り変わり (10-22 ユーザー「金色のただの線を飛び散らしているような感じ」「単色の線じゃなくて、火花っぽくグラデーションのある色に」)。
//   手本 = ゼンゼロの特殊ガードの火花 (docs/reference-library.md): 頭は白く焼け、黄・金を経て、尾は橙から暗い燠 (おき) の色へ冷めて消える。
//   すじごとに熱さが違い (白から始まる物・金から始まる物)、飛ぶほど冷めて頭も金・橙へ下がる。 火の粉も同じ色の道を通って冷める。
//   前の版 (金・琥珀の2色・上の STREAK_TONES) = DEV ?sparkGrad=off。 記録 = docs/research/2026-10-22-ukemi-guard-spark.md
//   青白混ぜ (10-22 ユーザー「青白い火花も混ぜたバージョンも見てみたい」) = DEV ?sparkMix=blue。 すじと火の粉の約 35% が BLUE_RAMP を通る。
//   青白7割 (10-23 ユーザー「青白混ぜ７割で作ったのを見てみたい。変だったら金から赤でいい」) = DEV ?sparkMix=blue70。 70% が BLUE_RAMP。
export type SparkMix = 'grad' | 'old' | 'blue' | 'blue70'
let sparkMix: SparkMix = (() => {
  if (!import.meta.env.DEV || typeof window === 'undefined') return 'grad'
  const q = new URLSearchParams(window.location.search)
  if (q.get('sparkGrad') === 'off') return 'old'
  const m = q.get('sparkMix')
  return m === 'blue' || m === 'blue70' ? m : 'grad'
})()
let sparkGrad = sparkMix !== 'old'
export function tehonSparkGradOn(): boolean { return sparkGrad }
export function setTehonSparkGradForTest(on: boolean): void { setTehonSparkMixForTest(on ? 'grad' : 'old') }
export function tehonSparkMix(): SparkMix { return sparkMix }
export function setTehonSparkMixForTest(m: SparkMix): void { sparkMix = m; sparkGrad = m !== 'old' }
/** 青白混ぜの時に青白へ回す割合。 */
export const SPARK_BLUE_SHARE = 0.35
/** 青白7割の時に青白へ回す割合。 */
export const SPARK_BLUE70_SHARE = 0.7
/** いまの版で青白へ回す割合 (今・前の版は 0)。 */
export function sparkBlueShare(): number { return sparkMix === 'blue' ? SPARK_BLUE_SHARE : sparkMix === 'blue70' ? SPARK_BLUE70_SHARE : 0 }
/** i 本目 (粒目) を青白にするか (salt ですじと火の粉を別の並びにする)。 */
export function sparkIsBlue(i: number, seed: number, salt: number): boolean {
  return h01(i * 7.77 + seed + salt) < sparkBlueShare()
}

/** 熱い (0) → 冷めた (1) の色。 赤までは行かず、尾の一番先は暗い橙 (燠) で消える。 */
export const SPARK_RAMP: readonly (readonly [number, RGB])[] = [
  [0, [255, 253, 242]],
  [0.12, [255, 245, 186]],
  [0.3, [255, 208, 102]],
  [0.52, [255, 156, 52]],
  [0.76, [236, 104, 36]],
  [1, [170, 66, 24]],
]
/** 青白の色の道 (白 → 淡い水色 → 氷の青 → 鋼の青)。 */
export const BLUE_RAMP: readonly (readonly [number, RGB])[] = [
  [0, [250, 253, 255]],
  [0.12, [222, 243, 255]],
  [0.3, [156, 212, 255]],
  [0.52, [100, 164, 244]],
  [0.76, [72, 114, 214]],
  [1, [48, 70, 150]],
]
type Ramp = readonly (readonly [number, RGB])[]
/** 色の道の u (0〜1) の色。 */
export function sparkRampAt(u: number, ramp: Ramp = SPARK_RAMP): RGB {
  const x = clamp01(u)
  for (let i = 1; i < ramp.length; i++) {
    const [u1, c1] = ramp[i]
    if (x > u1) continue
    const [u0, c0] = ramp[i - 1]
    const k = (x - u0) / (u1 - u0)
    return [Math.round(c0[0] + (c1[0] - c0[0]) * k), Math.round(c0[1] + (c1[1] - c0[1]) * k), Math.round(c0[2] + (c1[2] - c0[2]) * k)]
  }
  return ramp[ramp.length - 1][1]
}
/** すじの頭の冷め具合 (0 = 白熱・1 = 冷めきり)。 tone で生まれの熱さが違い (白熱 2 > 金 0 > 琥珀 1)、寿命の割合 p で冷める。 */
export function sparkHeadCool(tone: 0 | 1 | 2 | 3, p: number): number {
  const born = tone === 2 ? 0 : tone === 0 ? 0.08 : 0.2
  return clamp01(born + 0.42 * Math.pow(clamp01(p), 0.85))
}
/** 尾は頭の色からこの分だけ先 (冷めた側) まで抜ける。 */
const STREAK_TAIL_SPAN = 0.62
/** すじの長さに沿った濃さ (頭 0 → 尾 1)。 */
const STREAK_ALONG: readonly (readonly [number, number])[] = [[0, 1], [0.08, 0.96], [0.22, 0.8], [0.42, 0.52], [0.68, 0.24], [1, 0]]
/** 先細りの塗り (頭 hx,hy → 尾 tx,ty・一番太い所は頭から back だけ後ろ)。 */
function taper(ctx: CanvasRenderingContext2D, hx: number, hy: number, tx: number, ty: number, ux: number, uy: number, w: number, back: number): void {
  const bx = hx - ux * back, by = hy - uy * back
  ctx.beginPath()
  ctx.moveTo(hx + ux * w * 0.6, hy + uy * w * 0.6)
  ctx.lineTo(bx - uy * w * 0.5, by + ux * w * 0.5)
  ctx.lineTo(tx, ty)
  ctx.lineTo(bx + uy * w * 0.5, by - ux * w * 0.5)
  ctx.closePath()
  ctx.fill()
}
/** 色の移り変わる火花のすじ 1 本 (にじみ → 体 → 頭の近くだけ白く焼けた芯 → 頭の灯り)。 p = 寿命の割合。 */
function drawGradStreak(ctx: CanvasRenderingContext2D, hx: number, hy: number, ux: number, uy: number, len: number, w: number, back: number,
  tone: 0 | 1 | 2 | 3, p: number, alpha: number, ramp: Ramp = SPARK_RAMP): void {
  const at = (u: number) => sparkRampAt(u, ramp)
  const tx = hx - ux * len, ty = hy - uy * len
  const c0 = sparkHeadCool(tone, p)
  const span = Math.min(1 - c0, STREAK_TAIL_SPAN)
  // にじみは体より少し冷めた (橙寄りの) 色で広く薄く。
  for (const pass of [{ w: w * 2.6, a: 0.13, warm: 0.18 }, { w, a: 1, warm: 0 }]) {
    const g = ctx.createLinearGradient(hx, hy, tx, ty)
    for (const [u, k] of STREAK_ALONG) g.addColorStop(u, rgba(at(c0 + pass.warm + span * Math.pow(u, 0.55)), k * pass.a * alpha))
    ctx.fillStyle = g
    taper(ctx, hx, hy, tx, ty, ux, uy, pass.w, back)
  }
  // 色は頭の近くで早く移る (u^0.55)。 尾は薄くて見えにくいので、 見える所で白→金→橙が読めるように。
  const hot = 1 - c0 / 0.6
  if (hot > 0) {
    const cl = len * 0.45
    const g = ctx.createLinearGradient(hx, hy, hx - ux * cl, hy - uy * cl)
    g.addColorStop(0, rgba(TEHON_COLOR.white, 0.95 * hot * alpha))
    g.addColorStop(1, rgba(ramp[1][1], 0))
    ctx.fillStyle = g
    taper(ctx, hx, hy, hx - ux * cl, hy - uy * cl, ux, uy, w * 0.45, Math.min(cl * 0.2, 4))
  }
  // 頭の小さな灯り (冷めるほど白が消えて金・橙の灯りになる)。
  const hr = w * 1.6
  const hg = ctx.createRadialGradient(hx, hy, 0, hx, hy, hr)
  hg.addColorStop(0, rgba(at(c0 * 0.6), 0.65 * alpha))
  hg.addColorStop(0.4, rgba(at(c0 + 0.15), 0.32 * alpha))
  hg.addColorStop(1, rgba(at(c0 + 0.35), 0))
  ctx.fillStyle = hg
  ctx.fillRect(hx - hr, hy - hr, hr * 2, hr * 2)
}

/** 細く長い火花のすじ (頭が白く熱く、尾へ黄・金・橙・燠へ冷めて消える。 先細りの塗りで、均一な太さの線は使わない)。 世界座標の ctx。 */
export function drawTehonStreaks(ctx: CanvasRenderingContext2D, f: Spark, since: number, facing: 1 | -1, P: TehonParams = tehonP()): void {
  const S = P.streak
  if (sparkShape !== 'now' || since >= S.spawn + S.life[1]) return
  const seed = tehonSeed(f)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  for (let i = 0; i < S.count; i++) {
    const spec = tehonStreakSpec(i, seed, P)
    const at = tehonStreakAt(spec, since, P)
    if (!at || at.alpha <= 0.01) continue
    const hx = f.x + (spec.ox + at.x) * facing, hy = f.y + spec.oy + at.y
    const vx = at.vx * facing, vy = at.vy
    const v = Math.hypot(vx, vy)
    if (v < 1) continue
    const flown = Math.hypot(at.x, at.y)
    const len = Math.max(3, Math.min(S.lenMax, v * spec.trail, flown * S.detach))
    const ux = vx / v, uy = vy / v
    const tx = hx - ux * len, ty = hy - uy * len
    const w = spec.width * (0.75 + 0.25 * at.alpha)
    // 3周目: 太いにじみの頭が三角に広がって矢じりに見えた → にじみは細めに、一番太い所を頭より少し後ろへ下げる (針の形)。
    const back = Math.min(len * 0.22, 10)
    if (sparkGrad && spec.tone !== 3) {
      drawGradStreak(ctx, hx, hy, ux, uy, len, w, back, spec.tone, clamp01((since - spec.delay) / spec.life), at.alpha,
        sparkIsBlue(i, seed, 3.3) ? BLUE_RAMP : SPARK_RAMP)
      continue
    }
    const nx = -uy, ny = ux
    const tone = STREAK_TONES[spec.tone]
    // にじみ (太く薄い先細り) → 芯 (細い先細り)。 どちらも尾で太さ 0・濃さ 0。
    for (const pass of [{ w: w * 2.2, a: 0.16 }, { w, a: 1 }]) {
      const g = ctx.createLinearGradient(hx, hy, tx, ty)
      g.addColorStop(0, rgba(tone.head, pass.a * at.alpha))
      g.addColorStop(0.15, rgba(tone.body, 0.9 * pass.a * at.alpha))
      g.addColorStop(0.55, rgba(tone.body, 0.36 * pass.a * at.alpha))
      g.addColorStop(1, rgba(tone.body, 0))
      ctx.fillStyle = g
      ctx.beginPath()
      const bx = hx - ux * back, by = hy - uy * back
      ctx.moveTo(hx + ux * pass.w * 0.6, hy + uy * pass.w * 0.6)
      ctx.lineTo(bx + nx * pass.w * 0.5, by + ny * pass.w * 0.5)
      ctx.lineTo(tx, ty)
      ctx.lineTo(bx - nx * pass.w * 0.5, by - ny * pass.w * 0.5)
      ctx.closePath()
      ctx.fill()
    }
    // 頭の小さな灯り (燃えている粒・芯だけ白。 大きくすると矢じりに見えるので小さく)。
    const hr = w * 1.5
    const hg = ctx.createRadialGradient(hx, hy, 0, hx, hy, hr)
    hg.addColorStop(0, rgba(TEHON_COLOR.white, 0.6 * at.alpha))
    hg.addColorStop(0.35, rgba(tone.head, 0.35 * at.alpha))
    hg.addColorStop(1, rgba(tone.body, 0))
    ctx.fillStyle = hg
    ctx.fillRect(hx - hr, hy - hr, hr * 2, hr * 2)
  }
  ctx.restore()
}

// ---- ③ 接点の光の塊 -------------------------------------------------------------------------------
/** 輪郭のぼやけた大きな光の塊 (白い芯・金の中・淡い紫の外のにじみ)。 少し横長。 世界座標の ctx。 */
export function drawTehonBloom(ctx: CanvasRenderingContext2D, f: Spark, since: number, P: TehonParams = tehonP()): void {
  const b = tehonBloomAt(since, P)
  if (b.alpha <= 0.01) return
  const C = TEHON_COLOR
  const V = P.bloom.violet, G = P.bloom.gold
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const blob = (r: number, sx: number, stops: readonly [number, RGB, number][]) => {
    ctx.save()
    ctx.translate(f.x, f.y)
    ctx.scale(sx, 1)
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, r)
    for (const [o, c, a] of stops) g.addColorStop(o, rgba(c, a * b.alpha))
    ctx.fillStyle = g
    ctx.fillRect(-r, -r, r * 2, r * 2)
    ctx.restore()
  }
  const R = b.radius
  // 外: 淡い紫のにじみ (髪の色を少し・大きく)
  if (V > 0.01) blob(R * 2.1, 1.3, [[0, C.violet, 0.26 * V], [0.4, C.violet, 0.13 * V], [0.75, C.violet, 0.04 * V], [1, C.violet, 0]])
  // 中: 金のにじみ (大きく・中心は控えめ = 体の輪郭が透けて読める)
  blob(R * 1.2, 1.2, [[0, C.gold, 0.26 * G], [0.22, C.gold, 0.24 * G], [0.6, C.amber, 0.12 * G], [1, C.amber, 0]])
  // 芯: 白く飛ぶ所 (小さく・早く締まる)
  const core = 0.85 * Math.pow(b.alpha, 1.8)
  blob(R * 0.14, 1.15, [[0, C.white, core], [0.4, C.white, 0.5 * core], [0.75, C.warm, 0.12 * core], [1, C.warm, 0]])
  ctx.restore()
}

// ---- ④ 横一直線の光 -------------------------------------------------------------------------------
// 10-21 から出さない (ユーザー「横に一瞬映る金色の線みたいなやつ」「1回弾くだけでも」目が疲れる。 白い効果線を描かない 10-10 の決まりと同じ扱い)。
//   線だけを消し、明るさ・塊・火花のすじ・火の粉はそのまま。 前の版 = DEV ?parryFlare=on。 記録 = docs/research/2026-10-21-ukemi-tweak.md
let flareOn = (() => {
  if (!import.meta.env.DEV || typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get('parryFlare') === 'on'
})()
export function tehonFlareOn(): boolean { return flareOn }
export function setTehonFlareForTest(on: boolean): void { flareOn = on }
/**
 * 画面幅いっぱいの横の光。 均一な太さ・色の矩形や直線は使わない:
 *   横に潰したにじみ (放射のグラデーション) を長さ・太さ・中心をずらして重ねる = 中心ほど明るく太く、端へ細く薄く、濃淡が出る。
 *   消える時は太さが先に細り、少し伸びながら薄れる。 viewLeft = 画面の左端の世界 x、viewW = 画面幅。 世界座標の ctx。
 */
export function drawTehonFlare(ctx: CanvasRenderingContext2D, f: Spark, since: number, viewLeft: number, viewW: number, P: TehonParams = tehonP()): void {
  if (!flareOn) return
  const a = tehonFlareAt(since, P)
  if (a.alpha <= 0.01) return
  const C = TEHON_COLOR
  const seed = tehonSeed(f)
  const gain = P.flare.gain
  const V = Math.min(1.4, P.bloom.violet)
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  // 中心から画面の遠い端までの距離 = 横の光が画面の端まで届く長さの目安。
  const reach = Math.max(f.x - viewLeft, viewLeft + viewW - f.x, viewW * 0.5)
  const streak = (cx: number, hw: number, hh: number, stops: readonly [number, RGB, number][]) => {
    if (hh < 0.2) return
    ctx.save()
    ctx.translate(cx, f.y)
    ctx.scale(hw, hh)
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, 1)
    for (const [o, c, al] of stops) g.addColorStop(o, rgba(c, al * a.alpha * gain))
    ctx.fillStyle = g
    ctx.fillRect(-1, -1, 2, 2)
    ctx.restore()
  }
  const L = a.length, T = a.thick
  // 2回目: 画面の引きが広いので全体を太く。 消える時は芯 (白・金の帯) を先に引かせ、外のかすみは逆に少し太らせる
  //   = 細い一本線が残らず、薄いにじみとして消える。
  const coreK = Math.pow(1 - a.fade, 2.2), coreK2 = coreK * coreK
  const hazeT = (0.6 + 0.4 * Math.min(1, since / P.flare.in)) * (1 + 0.7 * smooth(a.fade))
  // 一番外: 画面の端まで届く薄い金のかすみ (太め・とても薄い)
  streak(f.x, reach * 1.25 * L, 42 * hazeT, [[0, C.gold, 0.2], [0.35, C.amber, 0.08], [1, C.amber, 0]])
  // 淡い紫のにじみ (髪の色を少し・片側へずらす)
  if (V > 0.05) streak(f.x + (h01(seed + 1.1) - 0.5) * 160, reach * 0.95 * L, 19 * hazeT, [[0, C.violet, 0.22 * V], [0.5, C.violet, 0.08 * V], [1, C.violet, 0]])
  // 中: 金の帯。 長さと中心の違う3枚を重ねて濃淡を作る
  for (let k = 0; k < 3; k++) {
    const off = (h01(seed + 2.3 + k * 1.7) - 0.5) * 220
    const hw = reach * (0.55 + 0.4 * h01(seed + 3.9 + k * 2.1)) * L
    const hh = (6 + 3.6 * h01(seed + 5.3 + k)) * T
    streak(f.x + off, hw, hh, [[0, C.warm, 0.42 * coreK], [0.25, C.gold, 0.3 * coreK], [0.7, C.amber, 0.08 * coreK], [1, C.amber, 0]])
  }
  // 中心のふくらみ: 接点の近くだけ太く明るい (中心ほど太く・端へ細く)
  streak(f.x, reach * 0.32 * L, 14 * T, [[0, C.warm, 0.5 * coreK], [0.3, C.gold, 0.28 * coreK], [0.7, C.amber, 0.06 * coreK], [1, C.amber, 0]])
  // 芯: 細い白。 中心のすぐ近くだけ一番明るい (消える時は真っ先に引く)
  streak(f.x, reach * 0.48 * L, 2.6 * T, [[0, C.white, coreK2], [0.3, C.warm, 0.65 * coreK2], [0.75, C.gold, 0.15 * coreK2], [1, C.gold, 0]])
  streak(f.x, 150 * L, 5 * T, [[0, C.white, 0.5 * coreK2], [0.5, C.warm, 0.2 * coreK2], [1, C.warm, 0]])
  ctx.restore()
}

// ---- ④' 斜めの光 ---------------------------------------------------------------------------------
/**
 * 接点を通る斜めの光 (ゼンゼロの斜めの帯)。 横の光と同じく潰したにじみを重ねる = 中心ほど明るく太く、端へ細く薄く消える。
 *   既定 = 淡い紫 2 本: 前上がりの長い帯と、逆向きの短く薄い帯。 色は主人公の髪のすみれ。
 *   wide (tehon-zzz) = 桃紫の太い帯 3 本が画面の端から端まで届く。 1 本ごとに長さ・中心をずらしたにじみを重ね、帯の中で明るさにむらを作る
 *     (均一な太さ・明るさの帯 = 棒の図形にしない)。 世界座標の ctx。
 */
export function drawTehonSlash(ctx: CanvasRenderingContext2D, f: Spark, since: number, facing: 1 | -1, viewW: number, P: TehonParams = tehonP()): void {
  const a = tehonSlashAt(since, P)
  if (a.alpha <= 0.01 || P.slash.gain <= 0) return
  const C = TEHON_COLOR
  const seed = tehonSeed(f)
  const gain = P.slash.gain
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const band = (deg: number, along: number, perp: number, hw: number, hh: number, stops: readonly [number, RGB, number][]) => {
    if (hh < 0.2 || hw < 1) return
    ctx.save()
    ctx.translate(f.x, f.y)
    ctx.rotate(deg * Math.PI / 180 * facing)
    ctx.translate(along, perp)
    ctx.scale(hw, hh)
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, 1)
    for (const [o, c, al] of stops) g.addColorStop(o, rgba(c, al * a.alpha * gain))
    ctx.fillStyle = g
    ctx.fillRect(-1, -1, 2, 2)
    ctx.restore()
  }
  const L = a.length
  if (!P.slash.wide) {
    const d1 = -30 - 10 * h01(seed + 21.1), d2 = 52 + 14 * h01(seed + 22.7)
    const o1 = (h01(seed + 23.3) - 0.3) * 120
    // 1本目 (前上がり・長い): 太いかすみ → にじんだ帯 (白い芯の線は入れない = 細い棒・光の筋に見せない)
    band(d1, o1, 0, viewW * 0.64 * L, 58, [[0, C.hair, 0.2], [0.4, C.violet, 0.09], [1, C.violet, 0]])
    band(d1, o1, 0, viewW * 0.52 * L, 20, [[0, C.violetPale, 0.32], [0.3, C.hair, 0.24], [0.7, C.violet, 0.07], [1, C.violet, 0]])
    // 2本目 (逆向き・短く薄い)
    band(d2, -o1 * 0.4, 0, viewW * 0.38 * L, 36, [[0, C.hair, 0.13], [0.45, C.violet, 0.05], [1, C.violet, 0]])
  } else {
    // ゼンゼロ寄り: 前上がりの 2 本 (平行に少しずらす) と逆向きの 1 本。 細るのは消える時だけ (濃さと一緒に太さも少し引く)。
    const thin = 0.75 + 0.25 * a.alpha
    const bands = [
      { deg: -28 - 8 * h01(seed + 31.1), perp: 0, len: 1.15, haze: 96, core: 30, k: 1 },
      { deg: -22 - 8 * h01(seed + 32.3), perp: 70 + 40 * h01(seed + 32.9), len: 0.95, haze: 60, core: 18, k: 0.7 },
      { deg: 50 + 12 * h01(seed + 33.7), perp: -20, len: 0.7, haze: 54, core: 16, k: 0.55 },
    ]
    for (let n = 0; n < bands.length; n++) {
      const B = bands[n]
      const hw = viewW * B.len * L
      // かすみ: 帯の外側 (太く薄い・端まで届く)
      band(B.deg, 0, B.perp, hw, B.haze * thin, [[0, C.pink, 0.2 * B.k], [0.5, C.pink, 0.12 * B.k], [0.85, C.violet, 0.03 * B.k], [1, C.violet, 0]])
      // 帯の中身: 長さ・中心の違うにじみを 3 枚重ねる (濃淡のむら)
      for (let m = 0; m < 3; m++) {
        const u = h01(seed + 40 + n * 7.1 + m * 2.3)
        const along = (u - 0.5) * hw * 0.7
        const w = hw * (0.35 + 0.3 * h01(seed + 41 + n * 5.3 + m * 1.9))
        const hh = B.core * (0.7 + 0.5 * h01(seed + 42 + n * 3.7 + m * 2.9)) * thin
        band(B.deg, along, B.perp, w, hh, [[0, C.pinkPale, 0.3 * B.k], [0.3, C.pink, 0.24 * B.k], [0.75, C.violet, 0.06 * B.k], [1, C.violet, 0]])
      }
    }
  }
  ctx.restore()
}

// ---- ⑤ 火の粉 -------------------------------------------------------------------------------------
export type EmberSpec = { born: number; ox: number; oy: number; ang: number; speed: number; life: number; size: number; violet: boolean }
/** i 粒目の火の粉。 接点のまわり (すじの散った先) で生まれ、上へ少し舞ってから漂い落ちる。 */
export function tehonEmberSpec(i: number, seed = 0, P: TehonParams = tehonP()): EmberSpec {
  const E = P.ember
  const r = (k: number) => h01(i * k + seed + 17.7)
  const dist = E.dist[0] + E.dist[1] * Math.pow(r(2.9), 0.7)
  const at = (r(3.3) - 0.5) * 2 * Math.PI
  return {
    born: E.born[0] + (E.born[1] - E.born[0]) * r(4.1),
    ox: Math.cos(at) * dist * 1.3, oy: Math.sin(at) * dist * 0.75,
    ang: -Math.PI / 2 + (r(5.7) - 0.5) * 2.6,
    speed: E.speed[0] + (E.speed[1] - E.speed[0]) * r(6.2),
    life: E.life[0] + (E.life[1] - E.life[0]) * r(7.4),
    size: E.size[0] + (E.size[1] - E.size[0]) * r(8.8),
    violet: r(9.9) < E.violet,
  }
}
export function tehonEmberAt(s: EmberSpec, since: number, P: TehonParams = tehonP()): { x: number; y: number; vx: number; vy: number; alpha: number } | null {
  const E = P.ember
  const lt = since - s.born
  if (lt < 0 || lt >= s.life) return null
  const e = Math.exp(-E.drag * lt)
  const d = s.speed * (1 - e) / E.drag
  const p = lt / s.life
  // ふっと灯って (2 コマ)、ゆっくり消える。 明滅しない。
  return { x: s.ox + Math.cos(s.ang) * d, y: s.oy + Math.sin(s.ang) * d + 0.5 * E.gravity * lt * lt,
    vx: Math.cos(s.ang) * s.speed * e, vy: Math.sin(s.ang) * s.speed * e + E.gravity * lt,
    alpha: Math.min(1, lt / (2 / 60)) * Math.pow(1 - p, E.fade) }
}
/** 光が引いた後に漂い落ちる火の粉 (小さな白い芯＋金/紫のにじみ)。 世界座標の ctx。 */
export function drawTehonEmbers(ctx: CanvasRenderingContext2D, f: Spark, since: number, facing: 1 | -1, P: TehonParams = tehonP()): void {
  const E = P.ember
  if (sparkShape !== 'now' || since < E.born[0] || since >= E.born[1] + E.life[1]) return
  const seed = tehonSeed(f)
  const C = TEHON_COLOR
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  for (let i = 0; i < E.count; i++) {
    const s = tehonEmberSpec(i, seed, P)
    const at = tehonEmberAt(s, since, P)
    if (!at || at.alpha <= 0.01) continue
    const x = f.x + at.x * facing, y = f.y + at.y
    const vx = at.vx * facing, vy = at.vy, v = Math.hypot(vx, vy)
    // 色の移り変わり (10-22): 金の粒が漂いながら橙・燠へ冷める (芯の白も冷めると黄へ下がる)。 前の版 = ?sparkGrad=off。
    const cool = sparkGrad && !s.violet ? clamp01(0.22 + 0.6 * clamp01((since - s.born) / s.life)) : -1
    const ramp = sparkIsBlue(i, seed, 9.1) ? BLUE_RAMP : SPARK_RAMP
    const body = s.violet ? C.violetPale : cool >= 0 ? sparkRampAt(cool, ramp) : C.gold
    const halo = s.violet ? C.violet : cool >= 0 ? sparkRampAt(cool + 0.25, ramp) : C.amber
    const core = cool >= 0 ? sparkRampAt(cool * 0.5, ramp) : C.white
    // 尾: 動く向きの後ろへ短い先細り (点の芯と同じ太さから 0 へ)。
    if (v > 1) {
      const len = Math.max(2, Math.min(14, v * E.tail)), ux = vx / v, uy = vy / v
      const w = s.size * 0.9, tx = x - ux * len, ty = y - uy * len
      const tg = ctx.createLinearGradient(x, y, tx, ty)
      tg.addColorStop(0, rgba(body, 0.85 * at.alpha))
      tg.addColorStop(1, rgba(halo, 0))
      ctx.fillStyle = tg
      ctx.beginPath()
      ctx.moveTo(x - uy * w, y + ux * w)
      ctx.lineTo(tx, ty)
      ctx.lineTo(x + uy * w, y - ux * w)
      ctx.closePath()
      ctx.fill()
    }
    // 芯のはっきりした点 (にじみは小さく = 玉ボケにしない)。
    const r = s.size * 2
    const g = ctx.createRadialGradient(x, y, 0, x, y, r)
    g.addColorStop(0, rgba(core, at.alpha))
    g.addColorStop(0.4, rgba(body, 0.9 * at.alpha))
    g.addColorStop(0.7, rgba(halo, 0.25 * at.alpha))
    g.addColorStop(1, rgba(halo, 0))
    ctx.fillStyle = g
    ctx.fillRect(x - r, y - r, r * 2, r * 2)
  }
  ctx.restore()
}

// ---- ① 画面の明るさ / 床と体の照り --------------------------------------------------------------
/** 画面全体が一瞬明るくなる (画面の論理座標の ctx = 世界の層を閉じた後・HUD の前)。 cx, cy = 接点の画面位置。 */
export function drawTehonScreenFlash(ctx: CanvasRenderingContext2D, since: number, cx: number, cy: number, w: number, h: number, P: TehonParams = tehonP()): void {
  const e = tehonFlashEnv(since, P)
  if (e <= 0.01) return
  const F = P.flash, C = TEHON_COLOR
  const spot2 = F.spotTint === C.warm ? C.gold : F.spotTint
  ctx.save()   // 変換は呼ぶ側のまま (画面の論理座標・高精細の倍率を含む)
  ctx.globalCompositeOperation = 'lighter'
  ctx.fillStyle = rgba(F.tint, F.peak * e)
  ctx.fillRect(0, 0, w, h)
  const R = Math.hypot(w, h) * 0.6
  const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, R)
  g.addColorStop(0, rgba(F.spotTint, F.spot * e))
  g.addColorStop(0.25, rgba(spot2, 0.5 * F.spot * e))
  g.addColorStop(0.6, rgba(spot2, 0.15 * F.spot * e))
  g.addColorStop(1, rgba(spot2, 0))
  ctx.fillStyle = g
  ctx.fillRect(0, 0, w, h)
  ctx.restore()
}
/** 床の照り返し (接点の真下の床が金に照る・横に潰したにじみ)。 世界座標の ctx・床の後・人物の前。 */
export function drawTehonFloorGlow(ctx: CanvasRenderingContext2D, f: Spark, since: number, floorY: number, P: TehonParams = tehonP()): void {
  const e = Math.max(tehonFlashEnv(since, P), 0.6 * tehonBloomAt(since, P).alpha)
  if (e <= 0.01) return
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.translate(f.x, floorY)
  ctx.scale(260, 22)
  const g = ctx.createRadialGradient(0, 0, 0, 0, 0, 1)
  g.addColorStop(0, rgba(TEHON_COLOR.warm, 0.42 * e))
  g.addColorStop(0.5, rgba(TEHON_COLOR.gold, 0.14 * e))
  g.addColorStop(1, rgba(TEHON_COLOR.gold, 0))
  ctx.fillStyle = g
  ctx.fillRect(-1, -1, 2, 2)
  ctx.restore()
}
/** 接点の光が二人の体の縁を照らす (src/parry_kesaki_fx.ts の drawKesakiLitBody に渡す光)。 */
export function tehonBodyLight(f: Spark, since: number, role: 'boss' | 'player', P: TehonParams = tehonP()) {
  const e = Math.max(tehonFlashEnv(since, P), tehonBloomAt(since, P).alpha * 0.7)
  return {
    x: f.x, y: f.y, radius: role === 'boss' ? 200 : 130,
    // 2回目: 白でなく金寄りに下げる (体が白く飛んで消えていた・戴冠獣が白っぽかった)。
    color: TEHON_COLOR.gold,
    alpha: e * (role === 'boss' ? 0.5 : 0.3), face: role === 'boss' ? 0.05 : 0.03, shift: 4, gain: 1,
  }
}
/** 体を照らす間か (照らしは体をもう一度描くので、要る間だけ)。 */
export function tehonBodyLit(since: number, P: TehonParams = tehonP()): boolean {
  return since < Math.max(P.flash.end, P.bloom.end, P.slash.end)
}
/**
 * やわらかい光 (塊・横・斜め・画面の明るさ) の上に主人公の体を描き直す濃さ (0〜1)。 光が強い間だけ、光の強さに合わせて。
 *   = 光に埋もれた上半身の輪郭を読ませる (逆光の中の姿)。 火花のすじと火の粉はこの後 (体の前) に描く。
 */
export function tehonVeilAlpha(since: number, P: TehonParams = tehonP()): number {
  if (P.veil <= 0 || !tehonBodyLit(since, P)) return 0
  const light = Math.max(tehonFlashEnv(since, P), tehonBloomAt(since, P).alpha, 0.7 * tehonSlashAt(since, P).alpha, flareOn ? 0.6 * tehonFlareAt(since, P).alpha : 0)
  return clamp01(P.veil * light)
}
/** 止めの長さ (ms)。 既定は前の長さのまま。 案によっては短く頭打ち (tehon-v1) か止めなし。 致命の弾きは呼ばない。 */
export function tehonParryStopMs(ms: number, active: boolean = look !== 'off', P: TehonParams = tehonP()): number {
  return active ? Math.min(ms, P.stopMs) : ms
}
/** 一番新しい「手本」の弾き (今の時刻で光が残っている物)。 */
export function activeTehonSpark(fx: readonly FxEvent[], now: number, active: boolean = look !== 'off', P: TehonParams = tehonP()): Spark | undefined {
  if (!active) return undefined
  const end = tehonEnd(P)
  let best: Spark | undefined
  for (const f of fx) {
    if (!tehonOwns(f, active)) continue
    const age = now - f.t
    if (age >= 0 && age < end && (!best || f.t >= best.t)) best = f
  }
  return best
}
